import React from 'react'
import PropTypes from 'prop-types'

import { isEmptyOrNil } from 'libs/empty'

import Fallbacks from './Fallbacks'
import ImageAvatars from './ImageAvatars'

const Avatars = (props) => {
  const { id, name, src, characters, className } = props
  return (
    <>
      {isEmptyOrNil(src) ? (
        <Fallbacks
          id={id}
          name={name}
          characters={characters}
          className={className}
          {...props}
        />
      ) : (
        <ImageAvatars name={name} src={src} className={className} {...props} />
      )}
    </>
  )
}

export default Avatars

Avatars.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  characters: PropTypes.string.isRequired,
}
